import { render, staticRenderFns } from "./UpdateTraveler.vue?vue&type=template&id=cb6be158&scoped=true"
import script from "./UpdateTraveler.vue?vue&type=script&lang=js"
export * from "./UpdateTraveler.vue?vue&type=script&lang=js"
import style0 from "./UpdateTraveler.vue?vue&type=style&index=0&id=cb6be158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6be158",
  null
  
)

export default component.exports